const partDensities = {
	/* part material : part density */
	'A-356' : 0.101,
	'A-357' : 0.101,
	'A-148' : 0.284,
};

export default partDensities;